import { render, staticRenderFns } from "./fence.vue?vue&type=template&id=2a1e8e80&scoped=true&"
import script from "./fence.vue?vue&type=script&lang=js&"
export * from "./fence.vue?vue&type=script&lang=js&"
import style0 from "./fence.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./fence.vue?vue&type=style&index=1&id=2a1e8e80&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1e8e80",
  null
  
)

export default component.exports